import React from 'react';
import { connect } from 'react-redux';
import '../assets/ak-cached/24h/css/channelLineup.css';
import * as ChannelBackend from '../action/channelLineup';
import { loaderActive } from './../action/loder';
import Loader from './loader';
import {catchJSException} from '../service/logService'
import ReactHtmlParser from 'react-html-parser';
import { updateSCTags } from '../service/dtmTag';

class ChannelLineup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.channelResults = React.createRef();
  }
  componentDidMount() {
  const {appState, lqState, packageid, dispatch, save, xpsEntry, isChangeFlow=false, changeTarCode, changeZipCode} = this.props;
   try{
    const tarCode = save.issmartcartflow ?  xpsEntry && xpsEntry.retrieveSmartCart && xpsEntry.retrieveSmartCart.tarCode || lqState.lqResponse.tarCode : this.props.flowType==="SUPP" ? lqState.selectedState.tarCode : lqState.lqResponse.tarCode;    
    loaderActive({ isLoaderActive: true }, dispatch);
    ChannelBackend.getChannelLineupbackend(
      appState.visitId,
      appState.visitorId,
      isChangeFlow ? changeTarCode : tarCode,
      isChangeFlow ? changeZipCode : (lqState.selectedState != null ? lqState.selectedState.zip : null),
      packageid,
      dispatch
    );
    
   }catch(ex){
    catchJSException('buildproduct',appState.visitId,'resumeCart',ex);
   }
  }
  
  searchOnChange = event => {
    this.channelResults.current.scrollTo(0, 0);
    let newSearchValue = event.target.value;
    ChannelBackend.searchOnChangeChannel(
      newSearchValue,
      this.props.channelLineupState.channels,
      this.props.dispatch
    );
  };
  clearSearch = () => {
    this.channelResults.current.scrollTo(0, 0);
    ChannelBackend.clearSearchChannelLineup(
      this.props.channelLineupState.channels,
      this.props.dispatch
    );
  };
  filterCategory = () => {
    this.channelResults.current.scrollTo(0, 0);
    ChannelBackend.filterCategoryChannel(
      this.props.channelLineupState.channels,
      this.props.channelLineupState.genreList,
      this.props.dispatch
    );
    setTimeout(() => {
      this.channelResults.current.focus();
    }, 1000)
    
  };
  filterChannelNumber = () => {
    this.channelResults.current.scrollTo(0, 0);
    ChannelBackend.filterChannelNumber(this.props.channelLineupState.channels, this.props.dispatch);
    setTimeout(() => {
      this.channelResults.current.focus();
    }, 1000)
  };
  filterAlpha = () => {
    this.channelResults.current.scrollTo(0, 0);
    ChannelBackend.filterAlpha(this.props.channelLineupState.channels, this.props.dispatch);
    setTimeout(() => {
      this.channelResults.current.focus();
    }, 1000)
  };
  filterGainLose = () => {
    this.channelResults.current.scrollTo(0, 0);
    ChannelBackend.filterGainLose(
      this.props.channelLineupState.comparePackages,
      this.props.dispatch
    );
    setTimeout(() => {
      this.channelResults.current.focus();
    }, 1000)
  };

  //Accessibility - view by channals by arrow keys
  handleArrowKeys = (e) => {
    
    let data = document.activeElement.id;
    // console.log("Last child  ----> " + data);
    // console.log("Last child Keycode ----> " + e.keyCode);

    if (data === 'atoz') {
      if(data === 'atoz' && e.keyCode === 39) {
        document.activeElement.nextElementSibling.focus();                
      }

      if(data === 'atoz' && e.keyCode === 35) {
        e.preventDefault();
        document.activeElement.nextElementSibling.focus();
        document.activeElement.nextElementSibling.focus();               
      }
    }

    if (data === 'category') {
      if(data === 'category' && e.keyCode === 39) {
        document.activeElement.nextElementSibling.focus();        
      }

      if(data === 'category' && e.keyCode === 37) {
        document.activeElement.previousElementSibling.focus();
      }

      if(data === 'category' && e.keyCode === 35) {
        e.preventDefault();
        document.activeElement.nextElementSibling.focus();               
      }

      if(data === 'category' && e.keyCode === 36) {
        e.preventDefault();
        document.activeElement.previousElementSibling.focus();              
      }
    }

    if (data === 'channel') {      
      if(data === 'channel' && e.keyCode === 39 && (typeof Element.nextElementSibling === undefined)) {
        // console.log("data exists", typeof Element.nextElementSibling === undefined)
        document.activeElement.nextElementSibling.focus();
      }

      if(data === 'channel' && e.keyCode === 37) {
        document.activeElement.previousElementSibling.focus();
      }

      if(data === 'channel' && e.keyCode === 36) {
        e.preventDefault();
        document.activeElement.previousElementSibling.focus();
        document.activeElement.previousElementSibling.focus();               
      }
    }

    if (data === 'gainlose') {
      if(data === 'gainlose' && e.keyCode === 37 && (typeof Element.nextElementSibling === undefined)) {
        document.activeElement.previousElementSibling.focus();
      }
    }
  }

  printPDF = () => {
    updateSCTags('Print Button Clicked');
    const mywindow = window.open('', 'PRINT', 'height=600,width=800');

    mywindow.document.write('<html><head><title>Channel Lineup</title>');
    mywindow.document.write('</head><body >');
    mywindow.document.write('<h2>' + this.props.channelLineupState.title + '</h2>');
    mywindow.document.write("<table style='float:left;  width:100%';>");

    const channels = this.props.channelLineupState.channels;
    channels.forEach(channel => {
      mywindow.document.write('<tr><td><span>' + channel.channelname + '</span>');
      mywindow.document.write("<span style='float: right'>" + channel.channelno + '</span>');
      mywindow.document.write('</td></tr>');
    });

    mywindow.document.write('</table>');
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
  };

  render() {
    const numPkgs = this.props.channelLineupState.selectedPkgs.length;
    const {disclaimerProductsFragments} = this.props
    const channelFilterBar = (
      <div className="channelFilter" role="tablist">
        <span aria-hidden="true">View by{' '}</span>
        <button
          role="tab" tabIndex={this.props.channelLineupState.active === 'alpha' ? '0' : '-1'} id="atoz"
          aria-selected={this.props.channelLineupState.active === 'alpha' ? 'true' : 'false'}
          className={this.props.channelLineupState.active === 'alpha' ? 'active' : undefined}
          onClick={this.filterAlpha} onKeyDown={(e) => this.handleArrowKeys(e)}
        >
          <span aria-label="View by A-Z">A-Z</span>
        </button>
        /
        <button
          role="tab" tabIndex={this.props.channelLineupState.active === 'genre' ? '0' : '-1'} id="category"
          aria-selected={this.props.channelLineupState.active === 'genre' ? 'true' : 'false'}
          className={this.props.channelLineupState.active === 'genre' ? 'active' : undefined}
          onClick={this.filterCategory} onKeyDown={(e) => this.handleArrowKeys(e)}
        >
          <span aria-label="View by Category">Category</span>
        </button>
        /
        <button
          role="tab" tabIndex={this.props.channelLineupState.active === 'num' ? '0' : '-1'} id="channel"
          aria-selected={this.props.channelLineupState.active === 'num' ? 'true' : 'false'}
          className={this.props.channelLineupState.active === 'num' ? 'active' : undefined}
          onClick={this.filterChannelNumber} onKeyDown={(e) => this.handleArrowKeys(e)}
        >
          <span aria-label="View by Channel #">Channel #</span>
        </button>{' '}
        /
        {numPkgs >= 2 && (
          <button
            role="tab" tabIndex={this.props.channelLineupState.active === 'gl' ? '0' : '-1'} id="gainlose"
            aria-selected={this.props.channelLineupState.active === 'gl' ? 'true' : 'false'}
            className={this.props.channelLineupState.active === 'gl' ? 'active' : undefined}
            onClick={this.filterGainLose} onKeyDown={(e) => this.handleArrowKeys(e)}
          >
            <span aria-label="View by Gain & Lose">Gain & Lose</span>
          </button>
        )}
      </div>
    );

    return (
      <div className="container" style={{border: "1px solid black"}}>
        <div className="corner">
          <span>{this.props.channelLineupState.location}</span>
          <button onClick={this.printPDF}>
            Print <span className="Icon Icon--print" />
          </button>
        </div>
        <Loader />
        <div className="splitContainer">
          {this.props.channelLineupState.comparePackages &&
            this.props.channelLineupState.comparePackages.map((item, index) => {
              return (
                <div className="title" key={index}>
                  <h2 className="modalHeaderExtender margin-top-medium margin-bottom-tiny">{item.title}</h2>
                  <span>
                    {item.numChannels}+ channels ({item.hdChannels} in HD)
                  </span>
                  {
                  (disclaimerProductsFragments && disclaimerProductsFragments.comBlackoutCLU && disclaimerProductsFragments.comBlackoutCLU.disclaimer) ?
                  <span id='comBlackoutCLU-disclaimer'>
                    {ReactHtmlParser(disclaimerProductsFragments.comBlackoutCLU.disclaimer)}
                  </span>
                   : null
                   }
                </div>
              );
            })}
        </div>
        <div className="channelSearch">
          <input
            type="text"
            value={this.props.channelLineupState.searchValue}
            onChange={this.searchOnChange}
            aria-labelledby="SearchID"
          />
          {this.props.channelLineupState.searchValue && (
            <button onClick={this.clearSearch}>Clear</button>
          )}
          <div
            className={
              this.props.channelLineupState.searchValue ? 'placeholder hide' : 'placeholder'
            }
            id="SearchID"
          >
            <span className="Icon Icon--search" /> Search for a channel from this list
          </div>
        </div>
        {channelFilterBar}
        <div className="channelResults" ref={this.channelResults} tabIndex="-1" id="channelResults">
          {this.props.channelLineupState.active === 'gl' ? (
            <React.Fragment>
              <ul className="channelList">
                {this.props.channelLineupState.results.map(result => {
                  return result.channelname ? (
                    <li className="channel">
                      {result.channelname}
                      <span>{result.channelno}</span>
                    </li>
                  ) : (
                    <li className="channel listTitle">{result}</li>
                  );
                })}
              </ul>
            </React.Fragment>
          ) : (
            this.props.channelLineupState.comparePackages &&
            this.props.channelLineupState.comparePackages.map((pkg, index) => {
              const pkgChannelList = pkg.channels.map(x => x.channelname);
              return (
                <ul className="channelList" key={index} tabIndex ="-1">
                  {this.props.channelLineupState.results.length > 0 ? this.props.channelLineupState.results.map(function(channel, index) {
                    let disabled = false;
                    if (pkgChannelList.indexOf(channel.channelname) === -1) {
                      disabled = true;
                    }
                    return channel.channelname ? (
                      <li key={index} className={'channel' + (disabled ? ' notAvailable' : '')}>
                        {' '}
                        <span className="channelName">{channel.channelname}</span> <span>{channel.channelno}</span>
                      </li>
                    ) : (
                      <li key={index} className="channel listTitle">
                        {channel}
                      </li>
                    );
                  }) : <div role="alert">No Results Found</div>}
                </ul>
              );
            })
          )}
        </div>        
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    lqState: state.loopQual,
    appState: state.app,
    channelLineupState: state.channelLineup,
    xpsEntry : state.xpsEntry,
    save : state.save,
    disclaimerProductsFragments : state.buildProduct.disclaimerProductsFragments || null
  };
};
export default connect(mapStateToProps)(ChannelLineup);
